import { render, staticRenderFns } from "./UrlTableCell.vue?vue&type=template&id=2b65fa36&scoped=true"
import script from "./UrlTableCell.vue?vue&type=script&lang=js"
export * from "./UrlTableCell.vue?vue&type=script&lang=js"
import style0 from "./UrlTableCell.vue?vue&type=style&index=0&id=2b65fa36&prod&scoped=true&lang=scss"
import style1 from "./UrlTableCell.vue?vue&type=style&index=1&id=2b65fa36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65fa36",
  null
  
)

export default component.exports